import { TimeUnitApi } from 'api-typings/common/common';
import {
  DurationApi,
  SubscriptionHistoryLogApi,
} from 'api-typings/memberships/memberships_types';
import {
  Duration,
  MembershipSubscriptionHistory,
} from './membership-subscription-history.model';

export function transformMembershipSubscriptionHistory(
  subscriptionHistoryLog: SubscriptionHistoryLogApi,
): MembershipSubscriptionHistory {
  return {
    id: subscriptionHistoryLog.id,
    packageId: subscriptionHistoryLog.package_id,
    timeStarted: subscriptionHistoryLog.time_started * 1000,
    timeEndedActual: subscriptionHistoryLog.time_ended_actual
      ? subscriptionHistoryLog.time_ended_actual * 1000
      : subscriptionHistoryLog.time_ended_actual,
    timeEndedExpected: subscriptionHistoryLog.time_ended_expected * 1000,
    priceId: subscriptionHistoryLog.price_id,
    periodId: subscriptionHistoryLog.period_id,
    status: subscriptionHistoryLog.status,
    userId: subscriptionHistoryLog.user_id,
    quantity: subscriptionHistoryLog.quantity,
    lastPaidTransactionId: subscriptionHistoryLog.last_paid_transaction_id,
    isTrial: subscriptionHistoryLog.is_trial,
    duration: transformDuration(subscriptionHistoryLog.duration),
  };
}

export function transformDuration(duration: DurationApi): Duration {
  return {
    id: duration.id,
    type: duration.type || TimeUnitApi.MONTH,
    cycle: duration.cycle || 1,
  };
}
